<script>
    import {createEventDispatcher} from 'svelte';
    import {store} from '../stores.js';
    import Sidebar from './Sidebar.svelte';
    import SideCart from './SideCart.svelte';

    const dispatch = createEventDispatcher();

    const user = store('credential', 'getAuth');
    const cart = store('cart-items', '', '[]');

    const axis = store('axis', '', false);
    const amo = store('amo', '', false);

    export let allow_leave = true;

    const handler_leave = (e) => {
        if (!allow_leave) {
            let popup = new bootstrap.Modal(document.getElementById('leave-locker'), {backdrop: 'static'});
                popup.show();

            dispatch('lock', {state: true});
        }
    };

    export let title = '';

    let scroll = () => {
        if (!$axis && !$amo) {
            let el = document.querySelector('.appHeader');

            if (el) {
                el.classList.toggle('is-active', window.scrollY >= 56);
            }
        }
    };
</script>

<svelte:window on:scroll={scroll} />

{#if !$axis && $user.id > 0}
    <!-- App Header -->
    <div class="appHeader bg-primary scrolled">
        <div class="left">
            <a href="#" class="headerButton" data-bs-toggle="offcanvas" data-bs-target="#sidebarPanel" on:click={handler_leave}>
                <i class="fas fa-bars fa-lg"></i>
            </a>
        </div>

        <div class="right">
            <slot name="right">
                <a href="#" class="headerButton" data-bs-toggle="offcanvas" data-bs-target="#cartPanel">
                    <i class="fas fa-shopping-cart fa-lg"></i>
                    {#if $cart.length}
                        <span class="badge badge-danger">{$cart.length}</span>
                    {/if}
                </a>
            </slot>
        </div>
    </div>
    <!-- * App Header -->

    <Sidebar />
    <SideCart />
{:else}
    <style>:global(.toast-box.toast-top.show) {top: 0!important;}</style>
{/if}
